import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyService } from '@nk/core/services/company.service';
import { SimpleSearchEntity } from '@nk/data-entities-lib';
import { getOrgNr } from '@nk/company-block';

@Component({
  selector: 'nk-top-search',
  templateUrl: './top-search.component.html',
  styleUrls: ['./top-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TopSearchComponent {
  constructor(
    private _router: Router,
    private _companyService: CompanyService,
  ) {}

  public manualSearch(searchQuery: string): void {
    if (getOrgNr(searchQuery)) {
      const { orgNr, orgNrSchema, valid } = getOrgNr(searchQuery); // turns  00000-0000 to SE00000-0000, guesses the schema based on input.
      if (valid) {
        this._companyService.companyCache.fetch(orgNrSchema + orgNr).subscribe(
          (company) => {
            if (company) {
              this._router.navigate(['/company', company.uuid]);
            } else {
              this.doFullSearch(searchQuery);
            }
          },
          (error: unknown) => this.doFullSearch(searchQuery),
        );
      } else {
        this.doFullSearch(searchQuery);
      }
    } else {
      this.doFullSearch(searchQuery);
    }
  }

  public doFullSearch(searchQuery: string): void {
    this._router.navigate(['/search', searchQuery]);
  }

  public onSimpleSearchEnterKeyPress(searchQuery: string): void {
    this.manualSearch(searchQuery);
  }

  public onSimpleSearchSelect(simpleSearchEntity: SimpleSearchEntity): void {
    if (simpleSearchEntity.search_target_type === 'MANUAL') {
      this.manualSearch(simpleSearchEntity.search_target);
    } else if (simpleSearchEntity.search_target_type === 'person') {
      const path = '/person/' + simpleSearchEntity.person_uuid;
      this._router.navigateByUrl(path);
    } else {
      const path = '/company/' + simpleSearchEntity.company_uuid;
      this._router.navigateByUrl(path);
    }
  }
}
